import { cn } from '@/shadcn/lib/utils';

export type BatchStatusGlyphKind = 'any' | 'running' | 'done' | 'failed';

type Props = {
  kind: BatchStatusGlyphKind;
  className?: string;
  'data-testid'?: string;
};

/**
 * Status mark drawn as a ring whose fill says how far the state got: dashed for
 * "any state", half-filled while running, solid with a check or a cross once it
 * settled. Takes its colour from `currentColor`; the check and cross are punched
 * out in the surface colour so they read on the filled disc in either theme.
 */
export function BatchStatusGlyph({
  kind,
  className,
  'data-testid': testId
}: Props) {
  return (
    <svg
      aria-hidden
      className={cn('size-3.5 shrink-0', className)}
      data-glyph={kind}
      data-testid={testId}
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      {kind === 'any' && (
        <circle
          cx="7"
          cy="7"
          r="5.25"
          stroke="currentColor"
          strokeDasharray="1.6 2.2"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      )}

      {kind === 'running' && (
        <>
          <circle
            cx="7"
            cy="7"
            r="5.25"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M7 7V1.75A5.25 5.25 0 0 1 7 12.25Z" fill="currentColor" />
        </>
      )}

      {(kind === 'done' || kind === 'failed') && (
        <circle cx="7" cy="7" fill="currentColor" r="6" />
      )}
      {kind === 'done' && (
        <path
          className="stroke-card"
          d="m4.4 7.2 1.9 1.9 3.4-4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      )}
      {kind === 'failed' && (
        <path
          className="stroke-card"
          d="m4.8 4.8 4.4 4.4m0-4.4-4.4 4.4"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      )}
    </svg>
  );
}
